module.exports = __webpack_public_path__ + "static/media/Artboard6.4817b26a.png";